export function parseError(error) {
    if (error?.response) {
        return error.response.data?.message || error.response.data?.error || error.response.data;
    }
    if (error?.message) {
        return error.message;
    }
    return typeof error === 'string' ? error : 'An unexpected error occurred';
}
